@if (spinnerService.isBusy()) {
  <div class="spinner-message">
    <mat-spinner [diameter]="150"></mat-spinner>
    <div class="run-query-message">
      {{ message | translate }}
    </div>
  </div>
}
